import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API_CONSTANTS } from "../../../API_CONSTANTS";

export const getProfile = createAsyncThunk("getProfile", async (paramsID) => {
  const response = await axios
    .get(`${API_CONSTANTS.BASEURL}admin/patients/${paramsID}`, {
      headers: API_CONSTANTS.headers(),
    })
    .then((res) => {
      return res.data.response.Item;
    });

  return response;
});
export const getProfileSlice = createSlice({
  name: "getPatientProfile",
  initialState: {
    value: {
      Fname: "",
      Id: "",
      phoneNo: "",
      email: "",
      gender: "",

      is_blocked: false,
      profiles: {
        self: {
          url: "https://img.icons8.com/material/72/000000/user-male-circle--v1.png",
          dob: "",
          mentalHealthIntakeForms: {
            patient_intake_form: {
              presentingComplaint: '',
              additionalNotes: '',
              consentConfirmed: false,
              durationOfConcern: {
                lessThan2Weeks: false,
                twoTo6Weeks: false,
                moreThanMonth: false,
              },
              immediateRisk: {
                none: true,
                mildFeelingOverwhelmed: false,
                moderateEmotionalDistress: false,
                highHarmToSelfOthers: false,
              },
              natureOfConcern: {
                abuse: {
                  emotionalVerbalAbuse: false,
                  physicalAbuse: false,
                  sexualAbuseAssault: false,
                  harassmentWorkplaceSchoolOnline: false,
                  traumaHistoryPastOngoing: false,
                  other: false,
                  otherText: '',
                },
                psychological: {
                  anxietyPanicWorry: false,
                  lowMoodDepressive: false,
                  stressBurnout: false,
                  lonelinessIsolation: false,
                  lowSelfWorthConfidence: false,
                  bodyImageSelfEsteem: false,
                  sleepAppetiteDisturbances: false,
                  thoughtsSelfHarmHopelessness: false,
                },
                family: {
                  conflictWithFamily: false,
                  relationshipWithCaregivers: false,
                  parentingConcerns: false,
                  lackOfSocialSupport: false,
                  peerPressureSocialAnxiety: false,
                  financialStrain: false,
                },
                marital: {
                  communicationDifficulties: false,
                  conflictResolution: false,
                  infidelityTrustIssues: false,
                  separationDivorceAdjustment: false,
                  balancingRolesExpectations: false,
                },
                adjustment: {
                  griefLoss: false,
                  lifeTransitionsRelocation: false,
                  chronicIllnessPain: false,
                  identityConcerns: false,
                  existentialSpiritualCrisis: false,
                },
                academic: {
                  performanceConcerns: false,
                  difficultyFocusing: false,
                  stressAroundTests: false,
                  absenteeism: false,
                  careerDirection: false,
                  studyProductivitySkills: false,
                  adjustmentToNewSchool: false,
                  transitionIssues: false,
                },
                behavioral: {
                  aggressiveWithdrawnBehavior: false,
                  difficultyEmotionalRegulation: false,
                  riskTakingImpulsiveBehaviors: false,
                  habitualCompulsiveBehaviors: false,
                  socialInterpersonalDifficulties: false,
                  substanceUseMisuse: false,
                  managingAuthorityFigures: false,
                },
              },
              patientDetails: {
                firstName: '',
                lastName: '',
                age: '',
                city: '',
                clientId: '',
                counsellorName: '',
                dateOfIntakeSession: '',
                gender: { male: false, female: false, other: false },
                languageSpoken: { english: false, urdu: false, other: false, otherText: '' },
              },
            },
            therapist_form: {
              basicInfo: {
                therapistName: '',
                firstName: '',
                lastName: '',
                age: '',
                dateOfIntake: '',
                educationLevel: '',
                occupation: '',
                sessionNumber: '',
                spouseName: '',
                primaryContactNumber: '',
                secondaryContactNumber: '',
                gender: { male: false, female: false, other: false },
                maritalStatus: { single: false, married: false, widowed: false, divorced: false },
                referralMadeBy: { parent: false, self: false, counselor: false },
              },
              briefPsychosocialHistory: {
                familyBackground: '',
                medicalHistory: '',
                academicWorkHistory: '',
                lifestyleFactors: '',
                socialLifeRelationships: '',
              },
              mentalHealthConcerns: {
                behavioral: { impulsivity: false, aggression: false, withdrawal: false, selfHarm: false },
                cognitive: { concentrationIssues: false, overthinking: false, negativeThinking: false },
                emotional: { anxiety: false, depression: false, anger: false, moodSwings: false },
                relational: { communicationProblems: false, conflictAtHomeWork: false, isolation: false },
                suicidalIdeation: '',
                traumaHistory: '',
              },
              presentingConcerns: {
                complaintDescription: '',
                clientUnderstandingOfCause: '',
                currentMedication: '',
                previousHelpSought: '',
              },
              therapistObservations: {
                clientOrientation: '',
                clientAffectInsightMotivation: '',
                immediateRedFlags: '',
                riskLevel: '',
              },
              summaryAndPlan: {
                tentativeDiagnosis: '',
                outlineShortTermGoals: '',
                howWillYouKnowGoalsAchieved: '',
                numberOfSessionsRequired: '',
                additionalComments: '',
                referralFollowUpRequired: { yes: false, no: false },
              },
              wellBeingSelfAssessment: {
                overallSatisfactionWithLife: 5,
                satisfactionWithJobStudies: 5,
                satisfactionWithPersonalRelationships: 5,
                satisfactionWithPhysicalHealth: 5,
                satisfactionWithMentalHealth: 5,
                satisfactionWithFinancialSituation: 5,
                satisfactionWithLivingEnvironment: 5,
              },
            },
          },
        },
        other: [],
      },
    },
  },
  reducers: {
    block: (state) => {
      state.value.is_blocked = true;
    },
    unblock: (state) => {
      state.value.is_blocked = false;
    },
  },
  extraReducers: {
    [getProfile.pending]: (state) => {
      state.loading = true;
    },
    [getProfile.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.value = payload;
    },
    [getProfile.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export const getPatientProfileReducer = getProfileSlice.reducer;
